export const INIT_DEFAULT_ROUTER = "INIT_DEFAULT_ROUTER";
export const UPDATE_MASTER_USER_ID = "UPDATE_MASTER_USER_ID";
export const GETTER_MASTER_USER_ID = "GETTER_MASTER_USER_ID";
export const GETTER_CURRENT_USER_ID = "GETTER_CURRENT_USER_ID";
export const INIT_CLIENT_ACTIONS = "INIT_CLIENT_ACTIONS";
export const UPDATE_CURRENT_USER_ID = "UPDATE_CURRENT_USER_ID";
export const TRANSFORM_ACCOUNT = "TRANSFORM_ACCOUNT";
export const GETTER_CURRENT_EARN_COINS_USER_ID =
  "GETTER_CURRENT_EARN_COINS_USER_ID";
export const UPDATE_CURRENT_EARN_COINS_USER_ID =
  "UPDATE_CURRENT_EARN_COINS_USER_ID";

export const CHANGE_CURRENT_INS_USER_ID = "CHANGE_CURRENT_INS_USER_ID";
